import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '@shared/services/security/auth.service';
import {PageTypesEnum} from "@shared/services/router/page-types.enum";
import {CONTRACTS_LIST_ROUTE} from '@shared/services/router/contract-routes';
import {ORGANISATIONS_LIST_ROUTE} from '@shared/services/router/organisation-routes';
import {Roles} from '@services/models/roles.enum';

@Component({
    selector: 'home',
    standalone: true,
    template: ''
})
export class HomeComponent implements OnInit {

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    ngOnInit(): void {
        if (!this.authService.isUserLogged) {
            if (this.authService.isUserPrelogged) {
                this.router.navigate(['step-two']);
            } else {
                this.router.navigate(['signin']);
            }
            return
        }

        // Contract admins (without the general Admin role) only get the contract screens.
        const roles = this.authService.roles ?? [];
        if (roles.includes(Roles.AdminContract) && !roles.includes(Roles.Admin)) {
            this.authService.setCurrentType(PageTypesEnum.CDSS);
            this.router.navigate([CONTRACTS_LIST_ROUTE]);
            return
        }

        // Organisation admins (without the general Admin role) only get the organisation screens.
        if (roles.includes(Roles.AdminOrg) && !roles.includes(Roles.Admin)) {
            this.authService.setCurrentType(PageTypesEnum.CDSS);
            this.router.navigate([ORGANISATIONS_LIST_ROUTE]);
            return
        }

        switch (this.authService.getCurrentType()) {
            case PageTypesEnum.ADMIN:
                if (this.authService.roles.includes(<Roles>'Admin')) {
                    this.authService.setCurrentType(PageTypesEnum.CDSS);
                }
                this.router.navigate(['cdss/admin-dashboard']);
                break
            case PageTypesEnum.CDSSADMIN:
                this.router.navigate(['select-type']);
                break
            case PageTypesEnum.CDSS:
                this.router.navigate(['cdss/dashboard']);
                break
            case PageTypesEnum.CTMS:
                this.router.navigate(['study-list']);
                break
            default:
                this.router.navigate(['select-type']);
        }
    }
}
